import React from "react";
import { ASSETS, CHAPTERS, STATS } from "@/data/content";
import { Reveal } from "./Reveal";

const About = () => {
  return (
    <section id="about" className="relative py-24 sm:py-32 bg-neutral-50 border-y border-gray-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Founder image, framed with interactive hover */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <div className="group afr-grain relative overflow-hidden rounded-3xl border border-gray-200 shadow-sm aspect-[4/5]">
                <img
                  src={ASSETS.founder}
                  alt="Mpilo Shabangu, Master A Flat at the piano"
                  className="absolute inset-0 h-full w-full object-cover object-center grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute bottom-5 left-5 text-white">
                  <p className="font-heading text-lg font-semibold tracking-tight">
                    Mpilo Shabangu
                  </p>
                  <p className="text-sm opacity-80">Master A Flat · Founder</p>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Numbered manifesto chapters */}
          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-sm font-medium tracking-widest text-neutral-400 mb-3">
                THE MANIFESTO
              </p>
              <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight mb-12">
                Built by creators,
                <br />
                for creators.
              </h2>
            </Reveal>

            <div className="space-y-10">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.08}>
                  <div className="flex gap-6 border-t border-gray-200 pt-6">
                    <span className="font-heading text-sm font-semibold text-playing pt-1 w-10 shrink-0">
                      {c.no}
                    </span>
                    <div>
                      <h3 className="font-heading text-xl font-semibold tracking-tight mb-2">
                        {c.title}
                      </h3>
                      <p className="text-neutral-600 leading-relaxed">{c.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-14">
              {STATS.map((s, i) => (
                <Reveal key={s.l} delay={i * 0.06}>
                  <div className="rounded-2xl border border-gray-200 bg-white p-5">
                    <p className="font-heading text-3xl font-semibold tracking-tight">{s.n}</p>
                    <p className="text-sm text-neutral-500 mt-1">{s.l}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
